import { CSSObject } from '@emotion/react';
import { theme } from 'styles';
import { mobile } from 'styles/media';

const { color, radius } = theme;

const wrap: CSSObject = {
  width: '1000px',
  maxWidth: '80vw',
  [mobile]: {
    width: '100%',
    maxWidth: 'none',
  },
};

const footer: CSSObject = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: '0 8px',
  marginTop: 20,
  [mobile]: {
    flexWrap: 'wrap',
    gap: 8,
    '> button': { flex: 1, height: 48 },
  },
};

const stickerSummary: CSSObject = {
  display: 'flex',
  alignItems: 'center',
  gap: '0 10px',
  marginBottom: 16,
  fontSize: 14,
  '> div': {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: color.grey600,
    borderRadius: radius.sm + 2,
    overflow: 'hidden',
  },
  img: { width: '100%', height: '100%', objectFit: 'contain' },
};

export { wrap, footer, stickerSummary };
